import { getRoot } from 'mobx-state-tree';
// import { IRootModel } from 'RootModel';
import schema, { generateType } from './Schema';
export const Repository = generateType(schema.getModel('repository'))
    .actions((self) => ({
    // This is an auto-generated example action.
    log() {
        console.log(JSON.stringify(self));
    },
    afterAttach() {
        // console.log('REPOSITORY after attach called');
        const rootModel = getRoot(self); // as IRootModel;
        if (rootModel && !rootModel.currentRepository) {
            rootModel.setCurrentRepository(self);
            // hack way to wait for adminSession to be initialized
            // rootModel.setStatus('ready');
        }
    },
}));
export const deployRepositoryGql = `
  mutation DeployRepository(
    $organizationID: String!
    $repositoryID: String!
  ) {
    deployRepository(
      organizationID: $organizationID
      repositoryID: $repositoryID
    ) {
      ${schema.getGqlPropertyList('repository', false, true, false).join(' ')}
    }
  }
`;
//# sourceMappingURL=RepositoryModel.js.map